import React from "react";
import CalendarIcon from "../../../assets/images/svg/plus.svg";
import MapIcon from "../../../assets/images/svg/location-dot.svg";
import ChevronDownIcon from "../../../assets/images/svg/chevron-down.svg";
import CircleDotIcon from "../../../assets/images/svg/circle-dot.svg";
import CircleQuestionIcon from "../../../assets/images/svg/circle-question.svg";

const ServicePlaningPreview = ({
  primaryText,
  secondaryText,
  actionColor,
  worshipPlaning,
}) => {

  const WorshipPlaningStatus = {
    Pending: 10,
    Tentative: 40,
  };

  const formatWorshipDetails = (event) => {
    const worshipDate = new Date(event.worshipDateFormatted);
    const formattedWorshipDate = worshipDate.toLocaleDateString("en-US", {
      weekday: "short", // Abbreviated weekday (e.g., "Sun")
      month: "short", // Abbreviated month (e.g., "Dec")
      day: "numeric", // Day of the month (e.g., "10")
    });

    const formattedTime = worshipDate.toLocaleTimeString("en-US", {
      hour: "2-digit", // 2-digit hour (e.g., "09")
      minute: "2-digit", // 2-digit minute (e.g., "00")
      hour12: true, // Use 12-hour format with AM/PM
    });

    return {
      worshipDate: formattedWorshipDate,
      formattedTime: formattedTime.toLowerCase(),
    };
  };

  const getEventDetailsByStatus = (status) => {
    return worshipPlaning
      .filter((item) => item.status === status)
      .map((item) => {
        const { worshipDate, formattedTime } = formatWorshipDetails(item.event);
        return {
          worshipDate,
          formattedTime,
          location: item.event.location,
          teamName: item.team.teamName,
          roleName: item.role.roleName,
        };
      });
  };

  const pendingDetails = getEventDetailsByStatus(WorshipPlaningStatus.Pending);
  const tentativeDetails = getEventDetailsByStatus(WorshipPlaningStatus.Tentative);

  const tentativeBlock = tentativeDetails.length > 0 && (
    <div className="card-tentative">
      <div className="card-head card-justify">
              <div className="card-text" style={{ color: secondaryText }}>
          Tentative
        </div>
              <div className="card-number" style={{ color: secondaryText }}>
          {tentativeDetails.length}
        </div>
      </div>
      {tentativeDetails.map((data) => (
        <div className="card-body">
          <div
                  className="card-text-primary card-row"
                  style={{ color: primaryText }}
          >
            {data.worshipDate}{" "}
                  <span className="card-text-time" style={{ color: primaryText }}>
            @{" "}{data.formattedTime}
            </span>
          </div>

          <div className="card-row">
            <div className="card-flex">
              <img
                          className="card-icon-map"
                          style={{ fill: primaryText }}
                src={MapIcon} />
              <div
                          className="card-text-secondary"
                          style={{ color: secondaryText }}
              >
                {data.location}
              </div>
            </div>
          </div>
          <div className="card-row">
            <div className="card-flex">
              <img
                className="card-icon-circle-dot"
                style={{ fill: "#1863CC" }}
                src={CircleDotIcon} />
              <div
                          className="card-text-secondary card-flex"
                          style={{ color: primaryText }}
              >
                {data.roleName}
                <li className="card-li" fill={primaryText}></li>
                <span
                              className="card-li-text"
                              style={{ color: secondaryText }}
                >
                  {data.teamName}
                </span>
              </div>
            </div>
          </div>
          <div className="card-button-container">
            <div className="card-btn-decline">
              <div
                          className="card-btn-decline-text"
              >
                Decline
              </div>
            </div>
            <div
              className="card-btn-accept"
                      style={{
                          backgroundColor: actionColor,
                          border: actionColor,
                      }}
            >
              <div className="card-btn-accept-text"> Accept </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  const pendingBlock = pendingDetails.length > 0 && (
    <div className="card-pending">
      <div className="card-head card-justify">
        <div className="card-text" style={{ color: secondaryText }}>
          Pending
        </div>
        <div className="card-number" style={{ color: secondaryText }}>
          {pendingDetails.length}
        </div>
      </div>
      {pendingDetails.map((data) => (
        <div className="card-body">
          <div
            className="card-text-primary card-row"
            style={{ color: primaryText }}
          >
            {data.worshipDate}{" "}
            <span className="card-text-time" style={{ color: primaryText }}>
            @{" "}{data.formattedTime}
            </span>
          </div>

          <div className="card-row">
            <div className="card-flex">
              <img
                className="card-icon-map"
                style={{ fill: primaryText }}
                src={MapIcon} />
              <div
                className="card-text-secondary"
                style={{ color: secondaryText }}
              >
                {data.location}
              </div>
            </div>
          </div>
          <div className="card-row">
            <div className="card-flex">
              <img
                className="card-icon-circle-dot"
                style={{ fill: "#E37542" }}
                src={CircleQuestionIcon} />
              <div
                className="card-text-secondary card-flex"
                style={{ color: primaryText }}
              >
                {data.roleName}
                <li className="card-li" fill={primaryText}></li>
                <span
                  className="card-li-text"
                  style={{ color: secondaryText }}
                >
                  {data.teamName}
                </span>
              </div>
            </div>
          </div>
          <div className="card-button-container">
            <div className="card-btn-decline">
              <div
                className="card-btn-decline-text"
              >
                Decline
              </div>
            </div>
            <div className="card-btn-tentative">
              <div
                className="card-btn-tentative-text"
              >
                Tentative
              </div>
            </div>
            <div
              className="card-btn-accept"
              style={{
                backgroundColor: actionColor,
                border: actionColor,
              }}
            >
              <div className="card-btn-accept-text"> Accept </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="servicePlanning-preview">
      <div className="card-first card-justify">
        <div className="card-first-item">
                  <div>Upcoming</div>
          <img src={ChevronDownIcon} />
        </div>

        {/* <div className="card-flex card-btn-border-cal">
          <img src={CalendarIcon} />
                  <div>My Availability</div>
        </div> */}
      </div>
      {tentativeBlock}
      {pendingBlock}
    </div>
  );
};

export default ServicePlaningPreview;
